import { useCanViewEmails } from '../../../../helpers/useCanViewEmails';
import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { SingleValue } from 'react-select';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import { useHotkeys } from 'react-hotkeys-hook';
import lodash from 'lodash';
import cs from 'classnames';

import {
  FILE_ACCESS_TYPE,
  FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP,
  GROUP,
  GROUP_WITH_SUBGROUP,
  USER,
  USER_NEW,
} from '../../../../enums/TYPES';
import { getFoldersThunk, removeSelectedFolder, switchShareModal, updateSharedFeed } from '../../../../store/folders/foldersSlice';
import {
  getFolderAccessessById,
  patchAccessDownloadPermission,
  patchFolderAccess,
  postArrayOfNewAccesses,
} from '../../../../api/foldersApi';

import {
  AccessMapJson,
  AccessType,
  DownloadType,
  NewAccessType,
  RenotifyIdType,
  Action,
  ActionKind,
  CreateAccessAction,
  CreateAccessBody,
  DeleteAccessAction,
  PatchAccessAction,
  PatchDownloadAction,
} from '../../MyFolderPage/ShareFolderModal';

import { SHARE_TYPE, GROUP_TYPE, VIDEOFEED_TYPE, SHARED_CONTENT_ENUM } from '../../../../enums/ENUMS';
import { ACCESS_TYPE, ACCESS_TYPE_ENUM, ACCESS_TYPE_KEYS } from '../../../../enums/ACCESS_ENUM';
import { USER_SHARE_OPTIONS } from '../../MyFolderPage/ShareFolderModal/UserList';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import useOnClickOutside from '../../../../helpers/useOnClickOutside';
import BellIconFilled from '../../../../assets/icons/bell-button-filled.svg';
import { getGroupsThunk } from '../../../../store/groups/groupsSlice';
import ShareModalExcludedUserList from '../../ExcludedUsersList';
import { getExcludeList, getUsersByRolesArray } from '../../../../api/usersApi';
import { postRenotify } from '../../../../api/notificationsApi';
import { RENOTIFY_BODY } from '../../../../enums/NOTIFICATION';
import LinearProgress from '../../../modules/LinearProgress';
import { ContainedButton, OutlinedButton } from '../../../modules/Buttons';
import { getDefaultShareAllowDownloads } from '../../../../helpers';
import { deleteAccess } from '../../../../api/accessesApi';
import useDebounce from '../../../../helpers/useDebounce';
import { RolesLowerCase } from '../../../../enums/ROLES';
import BellIcon from '../../../../assets/icons/share-notify-off.svg';
import UsersIcon from '../../../../assets/icons/users.svg';
import { getVideofeedAccessess } from '../../../../api';
import SearchInput from '../../../modules/SearchInput';
import { findSearchValue } from '../../../../helpers';
import { getGroups } from '../../../../api/groupsApi';
import ShareFolderModalGroupList from './GroupList';
import RolePlate from '../../../modules/RolePlate';
import ShareFolderModalUserList from './UserList';
import css from './ShareFeedModal.module.scss';
import AllUsersList from '../../AllUsersList';
import Avatar from '../../../modules/Avatar';
import Modal from '../../../modules/Modal';
import { PATHS } from '../../../../enums';
import { VIDEOFEED_WITH_SIZE } from '../../../SharedWithMe/SharedVideos/sharedVideosList';
import { Tooltip } from '@material-ui/core';

enum AccessTargetType {
  FOLDER = 'folder',
  REFLEX_COMPOSER = 'composer',
  ONLINE_COMPOSER = 'online_composer',
  COMPOSER = 'composer',
  TIMELINE = 'timeline',
}

type TShareFeedModal = {
  onUpdate?: React.Dispatch<React.SetStateAction<object>>;
  refetchFeeds: () => void;
};

const groupUsersOrganizer = (group: GROUP) => {
  return [...(group?.analysts || []), ...(group?.viewers || [])].filter(
    (value, index, self) => index === self.findIndex((user) => user.id === value.id),
  );
};

const ShareFeedModal: React.FC<TShareFeedModal> = ({ onUpdate, refetchFeeds }) => {
  const canViewEmails = useCanViewEmails();
  const searchResultBarRef = useRef(null);
  const searchGroupResultBarRef = useRef(null);
  const searchExcludedUsersResultBarRef = useRef(null);
  const contentWrapperRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const notification = useSnackbar();

  const {
    showShareWithMeModal,
    showShareModal,
    feedToShare: shareFolderForSharedWithMe,
    page,
    limit,
    sortOption,
  } = useAppSelector((state) => state.folderStore);
  const isOpen =
    (showShareModal || showShareWithMeModal) &&
    !!shareFolderForSharedWithMe;
  const { currentUser, myOrganization } = useAppSelector((state) => state.user);
  const { groups: allGroups } = useAppSelector((state) => state.groupsStore);

  const [thisFeed, setThisFeed] = useState<VIDEOFEED_WITH_SIZE | null>(null);
  const [userList, setUserList] = useState<FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP[]>([]);
  const [groupAccessList, setGroupAccessList] = useState<FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP[]>([]);
  const [subGroupAccessList, setSubGroupAccessList] = useState<FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP[]>([]);
  const [excludedUsersAccessList, setExcludedUsersAccessList] = useState<FILE_ACCESS_TYPE[]>([]);

  const [loading, setLoading] = useState(false);
  const [shareWithOrganization, setShareWithOrganization] = useState(false);
  const [orgDownloadPermission, setOrgDownloadPermission] = useState<boolean>(() => getDefaultShareAllowDownloads());

  const [idsToRenotify, setIdsToRenotify] = useState<RENOTIFY_BODY | null>(null);
  const [renotifyAll, setRenotifyAll] = useState(false);

  // планувальник змін (як у VideofeedShareModal)
  const actionQ = useRef<Action[]>([]);
  const [plannedOps, setPlannedOps] = useState<Action[]>([]);
  const [hasPending, setHasPending] = useState(false);
  const [upgradedCollectionAccessIds, setUpgradedCollectionAccessIds] = useState<string[]>([]);
  const [shareScopeOverrides, setShareScopeOverrides] = useState<Record<string, boolean>>({});
  const canGrantDownloads =
    String(thisFeed?.created_by?.id) === String(currentUser?.id) ||
    (thisFeed as any)?.highest_user_access?.allow_downloads === true ||
    (shareFolderForSharedWithMe as any)?.highest_user_access?.allow_downloads === true;
  const syncPlanned = () => {
    setPlannedOps([...actionQ.current]);
    setHasPending(actionQ.current.length > 0);
  };
  const enqueue = (a: Action) => {
    actionQ.current.push(a);
    syncPlanned();
  };
  const enqueueDownload = (accessId: string, allowDownload: boolean) => {
    for (let i = actionQ.current.length - 1; i >= 0; i--) {
      const act = actionQ.current[i];
      if (act.kind === ActionKind.PATCH_DOWNLOAD && (act as PatchDownloadAction).accessId === accessId) {
        (act as PatchDownloadAction).allowDownload = allowDownload;
        syncPlanned();
        return;
      }
    }
    enqueue({ kind: ActionKind.PATCH_DOWNLOAD, when: Date.now(), accessId, allowDownload });
  };
  const cancelCreateFor = (predicate: (a: CreateAccessAction) => boolean) => {
    actionQ.current = actionQ.current.filter((x) => !(x.kind === ActionKind.CREATE_ACCESS && predicate(x as CreateAccessAction)));
    syncPlanned();
  };
  const getAccessShareScope = (accessId: string): 'single' | 'collection' => {
    if (typeof shareScopeOverrides[accessId] === 'boolean') {
      return shareScopeOverrides[accessId] ? 'collection' : 'single';
    }
    const access = [...userList, ...groupAccessList, ...subGroupAccessList].find((item) => item.id === accessId);
    return String((access as any)?.share_scope || defaultAccessShareScope).toLowerCase() === 'single' ? 'single' : 'collection';
  };
  const currentShareScope =
    (shareFolderForSharedWithMe as any)?.highest_user_access?.share_scope ||
    (shareFolderForSharedWithMe as any)?.share_scope;
  const canManageCollectionShareScope = currentShareScope === 'collection';
  const defaultAccessShareScope: 'single' | 'collection' = canManageCollectionShareScope ? 'collection' : 'single';

  // відкладені видалення (передано з оригіналу)
  const [pendingDeleteIds, setPendingDeleteIds] = useState<string[]>([]);
  const queueDeletion = (...ids: string[]) => setPendingDeleteIds((prev) => [...prev, ...ids.filter((id) => !prev.includes(id))]);

  useEffect(() => {
    dispatch(getGroupsThunk());
  }, []);

  // ===== fetch feed =====
  const fetchThisFeedData = async () => {
    setLoading(true);
    try {
      const res = await getVideofeedAccessess(shareFolderForSharedWithMe?.id!);
      if (res.data) {
        setThisFeed(res.data);
      }
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.message) notification.showMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (shareFolderForSharedWithMe) {
      fetchThisFeedData();
    }
  }, [shareFolderForSharedWithMe]);

  // ===== Renotify all =====
  const switchNotifyAll = () => setRenotifyAll(!renotifyAll);

  const pushAllNewEntitiesToRenotify = () => {
    const users = [...(idsToRenotify?.userIds ?? [])];
    const groups = [...(idsToRenotify?.groupIds ?? [])];

    if (newUsersAccess) {
      Object.values(newUsersAccess).forEach((cfg) => {
        if (cfg.user) users.push(cfg.user);
      });
    }
    if (newGroupAccess) {
      Object.values(newGroupAccess).forEach((cfg) => {
        if (cfg.group) groups.push(cfg.group);
      });
    }
    if (userList.length) {
      userList.forEach((access) => users.push(access.user.id));
    }
    if (groupAccessList.length) {
      groupAccessList.forEach((access) => {
        if (!access.group) return;
        groups.push(access.group.id);
        access.group.subgroups.forEach((sub) => groups.push(sub.id));
      });
    }
    setIdsToRenotify((prev) => ({
      ...(prev ?? { userIds: [], groupIds: [], contentId: thisFeed!.id, contentType: idsToRenotify!.contentType }),
      userIds: users,
      groupIds: groups,
    }));
  };

  const determineAndSetVideofeedType = () => {
    if (!thisFeed) return;
    let feedType: SHARED_CONTENT_ENUM;
    switch (thisFeed.type) {
      case VIDEOFEED_TYPE.TIMELINE:
        feedType = SHARED_CONTENT_ENUM.SHARED_TIMELINE;
        break;
      case VIDEOFEED_TYPE.MY_COMPOSER:
      case VIDEOFEED_TYPE.ONLINE_COMPOSER:
        feedType = SHARED_CONTENT_ENUM.SHARED_ONLINE_COMPOSER;
        break;
      case VIDEOFEED_TYPE.REFLEX_COMPOSER:
      case VIDEOFEED_TYPE.COMPOSER:
        feedType = SHARED_CONTENT_ENUM.SHARED_COMPOSER;
        break;
      default:
        feedType = SHARED_CONTENT_ENUM.SHARED_TIMELINE;
        break;
    }
    setIdsToRenotify({
      userIds: [],
      groupIds: [],
      contentId: thisFeed.id,
      contentType: feedType,
    });
  };

  useEffect(() => {
    if (renotifyAll && idsToRenotify) {
      pushAllNewEntitiesToRenotify();
    } else if (thisFeed) {
      determineAndSetVideofeedType();
    }
  }, [renotifyAll]);

  useEffect(() => {
    if (!thisFeed) return;
    determineAndSetVideofeedType();

    const orgAccess = thisFeed?.access.find(
      (access) => access.type === 'organization' && access?.organization?.id == thisFeed.organization_id,
    );
    if (orgAccess) {
      setShareWithOrganization(true);
      setOrgDownloadPermission(!!orgAccess.allow_downloads);
    }
  }, [thisFeed]);

  const addEntityToRenotify = (id: string, type: RenotifyIdType, includeSubgroups?: GROUP) => {
    if (!idsToRenotify) return;
    if (type === RenotifyIdType.GROUP && includeSubgroups) {
      let groupIds = [...idsToRenotify.groupIds];
      if (groupIds.includes(id)) {
        groupIds = groupIds.filter((gid) => !includeSubgroups.subgroups.map((g) => g.id).includes(gid));
        groupIds = groupIds.filter((gid) => gid !== id);
      } else {
        groupIds = [...groupIds, id, ...includeSubgroups.subgroups.map((g) => g.id)];
      }
      setIdsToRenotify({ ...idsToRenotify, groupIds });
    } else if (type === RenotifyIdType.GROUP) {
      const groupIds = [...idsToRenotify.groupIds];
      const idx = groupIds.indexOf(id);
      if (idx >= 0) groupIds.splice(idx, 1);
      else groupIds.push(id);
      setIdsToRenotify({ ...idsToRenotify, groupIds });
    } else if (type === RenotifyIdType.USER) {
      const userIds = [...idsToRenotify.userIds];
      const idx = userIds.indexOf(id);
      if (idx >= 0) userIds.splice(idx, 1);
      else userIds.push(id);
      setIdsToRenotify({ ...idsToRenotify, userIds });
    }
  };

  // ===== helper / normalization =====
  const normalizeAccessTitle = (acc: any): ACCESS_TYPE_ENUM => {
    if (!acc) return ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    if (typeof acc === 'string') return acc as ACCESS_TYPE_ENUM;
    if (typeof acc === 'object' && 'title' in acc) return (acc.title as ACCESS_TYPE_ENUM) ?? ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    return ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
  };

  const isDeletedAccessId = (id?: string) =>
    !!id && actionQ.current.some((a) => a.kind === ActionKind.DELETE_ACCESS && (a as DeleteAccessAction).accessId === id);

  const updateCreateDraft = (type: 'group' | 'user' | 'organization', key: string, patch: Partial<CreateAccessBody>) => {
    for (let i = actionQ.current.length - 1; i >= 0; i--) {
      const act = actionQ.current[i];
      if (act.kind !== ActionKind.CREATE_ACCESS) continue;
      const c = act as CreateAccessAction;
      const matches =
        (type === 'group' && c.body.type === 'group' && c.body.group === key) ||
        (type === 'user' && c.body.type === 'user' && c.body.user === key) ||
        (type === 'organization' && c.body.type === 'organization' && c.body.organization === key);
      if (matches) {
        c.body = { ...c.body, ...patch };
        syncPlanned();
        return true;
      }
    }
    return false;
  };

  // ===== ефективний орг-доступ (для відновлення сабгруп і allowDownloads) =====
  const [downloadPermissions, setDownloadPermissions] = useState<DownloadType>({});
  const getEffectiveOrganizationAccess = () => {
    if (!thisFeed?.organization_id) return { exists: false as const };

    const orgId = String(thisFeed.organization_id);

    // draft має пріоритет
    const draft = newOrganizationAccess?.[orgId];
    if (draft) {
      return {
        exists: true as const,
        access: (draft.access as ACCESS_TYPE_ENUM) ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE,
        allow: typeof draft.allowDownloads === 'boolean' ? draft.allowDownloads : getDefaultShareAllowDownloads(),
        accessId: undefined as string | undefined,
      };
    }

    // існуючий, якщо не видаляється
    const existing = thisFeed.access.find((a) => a.type === 'organization' && String(a.organization?.id) === orgId);
    if (existing && !isDeletedAccessId(existing.id)) {
      let acc: ACCESS_TYPE_ENUM = existing.access?.title as ACCESS_TYPE_ENUM;
      for (let i = actionQ.current.length - 1; i >= 0; i--) {
        const act = actionQ.current[i];
        if (act.kind === ActionKind.PATCH_ACCESS && (act as PatchAccessAction).accessId === existing.id) {
          acc = (act as PatchAccessAction).access as ACCESS_TYPE_ENUM;
          break;
        }
      }
      let allow: boolean | undefined = downloadPermissions[existing.id]?.allowDownload;
      if (typeof allow !== 'boolean') {
        for (let i = actionQ.current.length - 1; i >= 0; i--) {
          const act = actionQ.current[i];
          if (act.kind === ActionKind.PATCH_DOWNLOAD && (act as PatchDownloadAction).accessId === existing.id) {
            allow = (act as PatchDownloadAction).allowDownload;
            break;
          }
        }
      }
      if (typeof allow !== 'boolean') allow = !!existing.allow_downloads;

      return { exists: true as const, access: acc, allow: allow!, accessId: existing.id };
    }

    return { exists: false as const };
  };

  // ===== access map =====
  const [accessMapJson, setAccessMapJson] = useState<AccessMapJson[]>([]);
  const rolesUpdater = (accesses: FILE_ACCESS_TYPE[]) =>
    accesses.map((obj) => {
      const modified = lodash.cloneDeep(obj);
      if (modified.user && modified.user.organization_users) {
        const foundObject = modified.user.organization_users.find((ob: any) => ob.organization.id === myOrganization?.id);
        if (foundObject) {
          modified.user.role = foundObject.role;
        }
      }
      return modified;
    });

  const accessArrayParser = (data: VIDEOFEED_WITH_SIZE) => {
    const userAccesses = data?.access.filter(
      (item) => item?.type === SHARE_TYPE.USER && !(item.access.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded),
    );
    const groupsAccesses = data?.access.filter(
      (item) => item?.type === SHARE_TYPE.GROUP && !(item.access.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded),
    );
    const excludedGroupsAccesses = data?.access.filter((item) => item?.type === SHARE_TYPE.GROUP && isExcludedAccess(item));
    const excludedUsersAccesses = data?.access.filter((item) => item?.type === SHARE_TYPE.USER && isExcludedAccess(item));

    const mainGroups = groupsAccesses?.filter((item) => item?.group?.type === GROUP_TYPE.GROUP);
    const subGroups = groupsAccesses?.filter((item) => item?.group?.type === GROUP_TYPE.SUBGROUP);

    if (subGroups) {
      let refetch = false;
      subGroups.forEach(async (subG) => {
        if (subG.group?.parent_group?.id && !mainGroups?.find((gr) => gr.group!.id == subG.group?.parent_group?.id)) {
          await deleteAccess(subG.id);
          refetch = true;
        }
      });

      if (refetch) {
        dispatch(getFoldersThunk({ page, limit, sortOption }));
        refetchFeeds?.();
        onUpdate?.({});
      }
    }

    const groupsWithAccessess: AccessMapJson[] = [];
    mainGroups.forEach((g) => {
      const parentGroup = allGroups.find((mainG) => mainG.id === g.group!.id);
      const obj: AccessMapJson = {
        id: g.group!.id,
        access: normalizeAccessTitle(g.access),
        subGroups: parentGroup?.subgroups.map((sub) => ({ id: sub.id, access: '' })) || [],
      };
      g.group!.subgroups.forEach((sub) => {
        const subGroupAccess = subGroups.find((subAcc) => subAcc.group!.id === sub.id);
        const indexOfSubgroup = obj.subGroups.findIndex((s) => s.id === sub.id);
        if (indexOfSubgroup >= 0) {
          obj.subGroups[indexOfSubgroup] = {
            ...obj.subGroups[indexOfSubgroup],
            access: normalizeAccessTitle(subGroupAccess?.access),
          };
        }
      });
      groupsWithAccessess.push(obj);
    });
    setAccessMapJson(groupsWithAccessess);

    // @ts-ignore
    setSubGroupAccessList(subGroups);
    // @ts-ignore
    setGroupAccessList([...mainGroups]);

    const userAccessesModified = rolesUpdater(userAccesses);
    const excludedUsersAccessesModified = rolesUpdater(excludedUsersAccesses);

    // @ts-ignore
    setUserList(userAccessesModified.filter((access) => access.user?.id !== currentUser?.id));
    setExcludedUsersAccessList([
      ...excludedUsersAccessesModified.filter((access) => access?.user?.id !== currentUser?.id),
      ...excludedGroupsAccesses,
    ]);
  };

  useEffect(() => {
    if (thisFeed) {
      accessArrayParser(thisFeed);
    }
  }, [thisFeed, allGroups]);

  // ===== search users =====
  const [searchedUsers, setSearchedUsers] = useState<USER_NEW[]>([]);
  const [isUserSearchLoading, setIsUserSearchLoading] = useState(false);
  const [isUserSearchEmpty, setIsUserSearchEmpty] = useState(false);
  const [searchText, setSearchText] = useState('');
  const debounce = useDebounce<string>(searchText, 500);
  const onUserSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    setIsUserSearchLoading(value.trim().length > 0);
    setIsUserSearchEmpty(false);
  };
  const fetchSearch = async () => {
    setIsUserSearchLoading(true);
    try {
      const ignoreUsers = [...userList.map((u) => u.user.id), ...newUsers.map((obj) => obj.user.id), currentUser?.id || ''];
      const res = await getUsersByRolesArray(
        [RolesLowerCase.ANALYST, RolesLowerCase.VIEWER, RolesLowerCase.ORGANIZATION_ADMIN],
        searchText,
        ignoreUsers,
      );
      setSearchedUsers(res.documents);
      setIsUserSearchEmpty((res.documents || []).length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsUserSearchLoading(false);
    }
  };
  useEffect(() => {
    if (!searchText && thisFeed) {
      setSearchedUsers([]);
      setIsUserSearchLoading(false);
      setIsUserSearchEmpty(false);
    } else if (searchText && thisFeed) fetchSearch();
  }, [debounce, thisFeed, switchShareModal, showShareModal]);

  // ===== search groups =====
  const [searchedGroups, setSearchedGroups] = useState<GROUP[]>([]);
  const [isGroupSearchLoading, setIsGroupSearchLoading] = useState(false);
  const [isGroupSearchEmpty, setIsGroupSearchEmpty] = useState(false);
  const [searchGroupText, setSearchGroupText] = useState('');
  const debounceGroup = useDebounce<string>(searchGroupText, 500);
  const onGroupSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchGroupText(value);
    setIsGroupSearchLoading(value.trim().length > 0);
    setIsGroupSearchEmpty(false);
  };
  const fetchSearchGroup = async () => {
    setIsGroupSearchLoading(true);
    try {
      const ignoreGroups = [
        ...groupAccessList.map((g) => g?.group?.id),
        ...newGroups.map((g: GROUP) => g.id),
        ...subGroupAccessList.map((sg) => sg?.group?.id),
      ];
      const res = await getGroups({ search: searchGroupText });
      const resultArr = res.documents.filter((org: GROUP_WITH_SUBGROUP) => !ignoreGroups.includes(org.id));
      setSearchedGroups(resultArr);
      setIsGroupSearchEmpty(resultArr.length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsGroupSearchLoading(false);
    }
  };
  useEffect(() => {
    if (!searchGroupText && thisFeed) {
      setSearchedGroups([]);
      setIsGroupSearchLoading(false);
      setIsGroupSearchEmpty(false);
    } else if (searchGroupText && thisFeed) fetchSearchGroup();
  }, [debounceGroup, thisFeed]);

  // ===== search exclusions =====
  const [searchedExclusions, setSearchedExclusions] = useState<(USER_NEW | GROUP)[]>([]);
  const [isExclusionsSearchLoading, setIsExclusionsSearchLoading] = useState(false);
  const [isExclusionsSearchEmpty, setIsExclusionsSearchEmpty] = useState(false);
  const [searchExclusionsText, setSearchExclusionsText] = useState('');
  const debounceExclusions = useDebounce<string>(searchExclusionsText, 500);
  const onExclusionsSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchExclusionsText(value);
    setIsExclusionsSearchLoading(value.trim().length > 0);
    setIsExclusionsSearchEmpty(false);
  };
  const fetchExclusions = async () => {
    setIsExclusionsSearchLoading(true);
    try {
      const ignoreUsers = [
        ...excludedUsersAccessList.filter((elem) => elem.user).map((access) => access.user!.id),
        ...(newExcludedUsers.filter((elem) => 'user_name' in elem) as USER_NEW[]).map((obj) => obj.user.id),
        currentUser?.id || '',
      ];

      const ignoreGroups = [
        ...excludedUsersAccessList.filter((elem) => elem.group).map((access) => access.group!.id),
        ...(newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]).map((obj) => obj.id),
      ];

      const res = await getExcludeList(searchExclusionsText, ignoreUsers, ignoreGroups);
      setSearchedExclusions(res);
      setIsExclusionsSearchEmpty((res || []).length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsExclusionsSearchLoading(false);
    }
  };
  useEffect(() => {
    if (!searchExclusionsText && thisFeed && allGroups?.length) {
      setSearchedExclusions([]);
      setIsExclusionsSearchLoading(false);
      setIsExclusionsSearchEmpty(false);
    } else if (searchExclusionsText && thisFeed) fetchExclusions();
  }, [debounceExclusions, thisFeed, allGroups]);

  // ===== group access change (PATCH + каскад) =====
  const [groupAccess, setGroupAccess] = useState<AccessType>();
  const onGroupAccessChange = (
    accessId: string,
    access: SingleValue<{ value: string; label: ACCESS_TYPE }>,
    groupId: string,
    groupType: GROUP_TYPE,
    accessObject?: FILE_ACCESS_TYPE,
  ) => {
    const isNoAccess = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS || access?.value === ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    const accessMapJsonCopied = lodash.cloneDeep(accessMapJson);
    const itsGroup = accessMapJsonCopied.find((g) => g.id === groupId);
    const itsSubgroup = accessMapJsonCopied.find((g) => g.subGroups.find((sub) => sub.id === groupId));
    if (itsGroup) {
      const idx = accessMapJsonCopied.findIndex((g) => g.id === itsGroup.id);
      accessMapJsonCopied[idx] = { ...accessMapJsonCopied[idx], access: access?.value! };
      if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
        accessMapJsonCopied[idx].subGroups = accessMapJsonCopied[idx].subGroups.map((s) => ({ ...s, access: access?.value! }));
      }
    } else if (itsSubgroup) {
      const gi = accessMapJsonCopied.findIndex((g) => g.id === itsSubgroup.id);
      const si = accessMapJsonCopied[gi].subGroups.findIndex((sub) => sub.id === groupId);
      accessMapJsonCopied[gi].subGroups[si] = { id: groupId, access: access?.value! };
    }
    setAccessMapJson(accessMapJsonCopied);

    // enqueue PATCH поточного accessId
    enqueue({
      kind: ActionKind.PATCH_ACCESS,
      when: Date.now(),
      accessId,
      access: access!.value,
      share_scope: getAccessShareScope(accessId),
      ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
      doNotNotify: access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS || undefined,
    });

    if (isNoAccess) {
      setDownloadPermissions((prev) => ({ ...prev, [accessId]: { allowDownload: false } }));
      enqueueDownload(accessId, false);
    }

    const obj = {
      ...groupAccess,
      [accessId]: {
        access: access!.value,
        ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
      },
    };

    if (
      access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS &&
      groupType === GROUP_TYPE.GROUP &&
      accessObject &&
      accessObject.group?.subgroups
    ) {
      accessObject.group.subgroups.forEach((sub) => {
        const subgroupAccessObject = subGroupAccessList.find((subAcc) => subAcc?.group?.id === sub.id);
        if (subgroupAccessObject) {
          enqueue({
            kind: ActionKind.PATCH_ACCESS,
            when: Date.now(),
            accessId: subgroupAccessObject.id,
            ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
            access: access!.value,
            share_scope: getAccessShareScope(subgroupAccessObject.id),
          });

          if (isNoAccess) {
            setDownloadPermissions((prev) => ({ ...prev, [subgroupAccessObject.id]: { allowDownload: false } }));
            enqueueDownload(subgroupAccessObject.id, false);
          }
        } else {
          const excluded = excludedUsersAccessList.some(
            (ex) => ex.type === 'group' && ex.group?.id === sub.id && ex.access?.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS,
          );
          if (!excluded) {
            enqueue({
              kind: ActionKind.CREATE_ACCESS,
              when: Date.now(),
              body: {
                // @ts-ignore
                targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
                targetId: thisFeed!.id,
                group: sub.id,
                allowDownloads: isNoAccess ? false : getDefaultShareAllowDownloads(),
                type: 'group',
                access: access!.value,
                share_scope: defaultAccessShareScope,
                ...(isNoAccess ? { excluded: false } : {}),
              },
            });
          }
        }
      });
    }

    setGroupAccess((prev) => ({ ...prev, ...obj }));
  };

  // ===== new group access change (CREATE + каскад) =====
  const [newGroups, setNewGroups] = useState<GROUP[]>([]);
  const [newGroupAccess, setNewGroupAccess] = useState<NewAccessType>();
  const onNewGroupAccessChange = (
    groupId: string,
    access: SingleValue<{ value: string; label: ACCESS_TYPE }>,
    groupType: GROUP_TYPE,
    groupObj?: GROUP_WITH_SUBGROUP,
  ) => {
    const isNoAccess = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS || access?.value === ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    const allow = isNoAccess ? false : getDefaultShareAllowDownloads();

    const parent = allGroups.find((g) => g.id === groupId) || newGroups.find((g) => g.id === groupId);
    const subIds = new Set((parent?.subgroups ?? []).map((s) => s.id));
    actionQ.current = actionQ.current.filter((a) => {
      if (a.kind !== ActionKind.CREATE_ACCESS) return true;
      const c = a as CreateAccessAction;
      if (c.body.type !== 'group') return true;
      const gid = c.body.group!;
      return gid !== groupId && !subIds.has(gid);
    });
    syncPlanned();

    // локальна мапа
    const copied = lodash.cloneDeep(accessMapJson);
    const asGroup = copied.find((g) => g.id === groupId);
    const asSub = copied.find((g) => g.subGroups.find((s) => s.id === groupId));
    if (asGroup) {
      const gi = copied.findIndex((g) => g.id === asGroup.id);
      copied[gi] = { ...copied[gi], access: access?.value! };
      if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
        copied[gi].subGroups = copied[gi].subGroups.map((s) => ({ ...s, access: access?.value! }));
      }
    } else if (asSub) {
      const gi = copied.findIndex((g) => g.id === asSub.id);
      const si = copied[gi].subGroups.findIndex((s) => s.id === groupId);
      copied[gi].subGroups[si] = { id: groupId, access: access?.value! };
    } else if (groupType === GROUP_TYPE.GROUP) {
      const already = copied.find((g) => g.id === groupId);
      const parentGroup = allGroups.find((g) => g.id === groupId);
      if (already) {
        const gi = copied.findIndex((g) => g.id === already.id);
        copied[gi] = { ...copied[gi], access: access?.value! };
      } else if (parentGroup) {
        copied.push({
          id: groupId,
          access: access?.value!,
          subGroups: parentGroup.subgroups.map((s) => ({ id: s.id, access: '' })),
        });
      }
    }
    setAccessMapJson(copied);

    const patched = updateCreateDraft('group', String(groupId), {
      access: access!.value,
      allowDownloads: allow,
      share_scope: newGroupAccess?.[groupId]?.share_scope || defaultAccessShareScope,
      ...(isNoAccess ? { excluded: false } : {}),
      ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
    });

    if (!patched) {
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          group: groupId,
          allowDownloads: allow,
          type: 'group',
          access: access!.value,
          share_scope: newGroupAccess?.[groupId]?.share_scope || defaultAccessShareScope,
          ...(isNoAccess ? { excluded: false } : {}),
          ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
        },
      });
    }

    // каскад CREATE на сабгрупи, якщо треба
    if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS && groupType === GROUP_TYPE.GROUP && groupObj) {
      groupObj.subgroups.forEach((sub) => {
        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: {
            // @ts-ignore
            targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
            targetId: thisFeed!.id,
            group: sub.id,
            allowDownloads: allow,
            type: 'group',
            access: access!.value,
            share_scope: newGroupAccess?.[sub.id]?.share_scope || defaultAccessShareScope,
            ...(isNoAccess ? { excluded: false } : {}),
          },
        });
      });
    }

    const obj: NewAccessType = {
      ...(newGroupAccess ?? {}),
      [groupId]: {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        group: groupId,
        allowDownloads: allow,
        type: 'group',
        access: access!.value,
        share_scope: newGroupAccess?.[groupId]?.share_scope || defaultAccessShareScope,
        ...(isNoAccess ? { excluded: false } : {}),
        ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
      },
    };
    if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS && groupType === GROUP_TYPE.GROUP && groupObj) {
      groupObj.subgroups.forEach((sub) => {
        (obj as any)[sub.id] = {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          group: sub.id,
          allowDownloads: allow,
          type: 'group',
          access: access!.value,
          share_scope: newGroupAccess?.[sub.id]?.share_scope || defaultAccessShareScope,
          ...(isNoAccess ? { excluded: false } : {}),
        };
      });
    }
    setNewGroupAccess((prev) => ({ ...(prev ?? {}), ...obj }));
  };

  // ===== users access change (PATCH) =====
  const [usersAccess, setUsersAccess] = useState<AccessType>();
  const onUserAccessChange = (accessId: string, access: SingleValue<{ value: string; label: ACCESS_TYPE }>) => {
    enqueue({
      kind: ActionKind.PATCH_ACCESS,
      when: Date.now(),
      accessId,
      access: access!.value,
      share_scope: getAccessShareScope(accessId),
      ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
    });
    setUpgradedCollectionAccessIds((prev) => (prev.includes(accessId) ? prev : [...prev, accessId]));
    const obj = {
      ...usersAccess,
      [accessId]: {
        access: access!.value,
      },
    };
    setUsersAccess(obj);
  };

  const onShareScopeChange = (accessObject: any, accessId: string, shareAllTimelines: boolean) => {
    const share_scope = shareAllTimelines ? 'collection' : 'single';
    setShareScopeOverrides((prev) => ({ ...prev, [accessId]: shareAllTimelines }));
    enqueue({
      kind: ActionKind.PATCH_ACCESS,
      when: Date.now(),
      accessId,
      access: accessObject.access.title,
      share_scope,
      excluded: false,
    });
  };

  // ===== download permission change (PATCH_DOWNLOAD) =====
  const onDownloadPermissionChange = (accessObject: any, accessId: string, allowDownload: boolean) => {
    // якщо нема accessId — це новий драфт (група/сабгрупа); оновимо draft
    if (!accessId) {
      const draftId = accessObject?.group?.id || accessObject?.id || undefined;
      if (draftId && newGroupAccess?.[draftId]) {
        const next = { ...newGroupAccess };
        next[draftId].allowDownloads = allowDownload;
        setNewGroupAccess(next);
        updateCreateDraft('group', String(draftId), { allowDownloads: allowDownload });
      }
      return;
    }

    const selectedGroupAccess = groupAccessList.find((a) => a.id === accessId);
    const copy: DownloadType = { ...downloadPermissions };

    // каскад на сабгрупи при тумблері групи
    if (selectedGroupAccess?.group) {
      const subgroupIds = selectedGroupAccess.group.subgroups.map((s) => s.id);
      const existingSubAccesses = subGroupAccessList.filter((a) => subgroupIds.includes(a.group!.id)).map((a) => a.id);
      existingSubAccesses.forEach((sid) => {
        copy[sid] = { allowDownload };
        enqueueDownload(sid, allowDownload);
      });

      if (newGroupAccess) {
        const next = { ...newGroupAccess };
        subgroupIds.forEach((sgId) => {
          if (next[sgId]) {
            next[sgId].allowDownloads = allowDownload;
            updateCreateDraft('group', String(sgId), { allowDownloads: allowDownload });
          }
        });
        setNewGroupAccess(next);
      }
    }

    copy[accessId] = { allowDownload };
    setDownloadPermissions((prev) => ({ ...prev, ...copy }));
    enqueueDownload(accessId, allowDownload);
  };

  // ===== org download toggle (PATCH_DOWNLOAD/CREATE sync) =====
  const onOrgDownloadPermissionChange = () => {
    const next = !orgDownloadPermission;
    setOrgDownloadPermission(next);

    const orgId = thisFeed!.organization_id.toString();
    const existingOrg = thisFeed?.access.find((a) => a.type === 'organization' && String(a.organization?.id) === orgId);
    if (existingOrg && !isDeletedAccessId(existingOrg.id)) {
      setDownloadPermissions((prev) => ({ ...prev, [existingOrg.id]: { allowDownload: next } }));
      enqueueDownload(existingOrg.id, next);
      return;
    }

    setNewOrganizationAccess((prev) => {
      const desiredAccess = prev?.[orgId]?.access ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const nextMap: NewAccessType = {
        ...(prev ?? {}),
        [orgId]: {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          organization: orgId,
          type: 'organization',
          access: desiredAccess,
          allowDownloads: next,
        },
      };
      return nextMap;
    });

    const updated = updateCreateDraft('organization', orgId, { allowDownloads: next });
    if (!updated) {
      const accessForCreate = newOrganizationAccess?.[orgId]?.access ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          organization: orgId,
          type: 'organization',
          access: accessForCreate,
          allowDownloads: next,
        },
      });
    }
    syncPlanned();
  };

  // ===== new users (CREATE) =====
  const [newUsers, setNewUsers] = useState<USER_NEW[]>([]);
  const [newUsersAccess, setNewUsersAccess] = useState<NewAccessType>();
  const onNewUserAccessChange = (userId: string, access: SingleValue<{ value: string; label: ACCESS_TYPE }>) => {
    setSearchedUsers([]);
    setNewUsersAccess((prev) => {
      const baseDraft = prev?.[userId] ?? {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        user: userId,
        type: 'user',
        allowDownloads: getDefaultShareAllowDownloads(
          newUsers.find((item) => item.user.id === userId)?.role?.title,
        ),
      };
      const withExcluded = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};
      const nextForUser = { ...baseDraft, access: access!.value, share_scope: (baseDraft as any).share_scope || defaultAccessShareScope, ...withExcluded };
      const next = { ...(prev ?? {}), [userId]: nextForUser };

      const updated = updateCreateDraft('user', userId, {
        access: access!.value,
        allowDownloads: nextForUser.allowDownloads,
        share_scope: nextForUser.share_scope,
        ...withExcluded,
      });
      if (!updated) {
        enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: nextForUser as any });
      }
      syncPlanned();
      return next;
    });
  };
  const onNewUserShareScopeChange = (userId: string, shareAllTimelines: boolean) => {
    const share_scope = shareAllTimelines ? 'collection' : 'single';
    setNewUsersAccess((prev) => {
      const next = { ...(prev || {}) };
      if (next[userId]) next[userId] = { ...next[userId], share_scope };
      updateCreateDraft('user', userId, { share_scope });
      return next;
    });
  };
  const onNewUserDownloadPermissionChange = (userId: string, allowDownload: boolean) => {
    setSearchedUsers([]);
    setNewUsersAccess((prev) => {
      if (!prev?.[userId]) return prev;
      const next = { ...prev, [userId]: { ...prev[userId], allowDownloads: allowDownload } };
      const updated = updateCreateDraft('user', userId, { allowDownloads: allowDownload });
      if (!updated) {
        enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: next[userId] as any });
      }
      syncPlanned();
      return next;
    });
  };

  // ===== new group download toggle (CREATE sync) =====
  const onNewGroupDownloadPermissionChange = (groupId: string, allowDownload: boolean) => {
    setSearchedGroups([]);
    const lookupAccessFor = (id: string): ACCESS_TYPE_ENUM => {
      const asGroup = accessMapJson.find((g) => g.id === id);
      if (asGroup) return (asGroup.access as ACCESS_TYPE_ENUM) || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const parent = accessMapJson.find((g) => g.subGroups?.some((s) => s.id === id));
      if (parent) {
        const sg = parent.subGroups.find((s) => s.id === id);
        return (sg?.access as ACCESS_TYPE_ENUM) || (parent.access as ACCESS_TYPE_ENUM) || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      }
      return ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
    };

    setNewGroupAccess((prev) => {
      const next = { ...(prev ?? {}) };
      const currentAcc = lookupAccessFor(groupId);
      const withExcluded = currentAcc === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};

      if (!next[groupId]) {
        next[groupId] = {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          group: groupId,
          allowDownloads: allowDownload,
          type: 'group',
          access: currentAcc,
          share_scope: defaultAccessShareScope,
          ...withExcluded,
        };
        const updated = updateCreateDraft('group', String(groupId), {
          allowDownloads: allowDownload,
          access: next[groupId].access,
          share_scope: next[groupId].share_scope,
          ...withExcluded,
        });
        if (!updated) enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: next[groupId] as any });
      } else {
        next[groupId].allowDownloads = allowDownload;
        updateCreateDraft('group', String(groupId), { allowDownloads: allowDownload });
      }

      const selectedGroup = newGroups.find((g) => g.id === groupId);
      if (selectedGroup?.subgroups?.length) {
        selectedGroup.subgroups.forEach(({ id }) => {
          const accForSub = lookupAccessFor(id);
          const exclForSub = accForSub === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};

          if (!next[id]) {
            next[id] = {
              // @ts-ignore
              targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
              targetId: thisFeed!.id,
              group: id,
              allowDownloads: allowDownload,
              type: 'group',
              access: accForSub || next[groupId].access,
              share_scope: defaultAccessShareScope,
              ...exclForSub,
            };
            const upd = updateCreateDraft('group', String(id), {
              allowDownloads: allowDownload,
              access: next[id].access,
              share_scope: next[id].share_scope,
              ...exclForSub,
            });
            if (!upd) enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: next[id] as any });
          } else {
            next[id].allowDownloads = allowDownload;
            updateCreateDraft('group', String(id), { allowDownloads: allowDownload });
          }
        });
      }
      return next;
    });
  };

  const onNewGroupShareScopeChange = (groupId: string, shareAllTimelines: boolean) => {
    const share_scope = shareAllTimelines ? 'collection' : 'single';
    setNewGroupAccess((prev) => {
      const next = { ...(prev || {}) };
      next[groupId] = { ...(next[groupId] || {}), share_scope } as any;
      updateCreateDraft('group', groupId, { share_scope });
      return next;
    });
  };

  // ===== org access change (PATCH/CREATE) =====
  const [newOrganizationAccess, setNewOrganizationAccess] = useState<NewAccessType>();
  const onNewOrganizationAccessChange = (access: SingleValue<{ value: string; label: ACCESS_TYPE }>, downloadPermission?: boolean) => {
    let obj = {} as any;
    const orgAccess = thisFeed?.access.find((a) => a.type === 'organization');

    if (orgAccess && pendingDeleteIds.includes(orgAccess.id)) {
      setPendingDeleteIds(pendingDeleteIds.filter((id) => id !== orgAccess.id));
      return;
    }

    if (orgAccess) {
      const desiredAccess = access?.value ?? orgAccess.access.title;
      const desiredAllow = typeof downloadPermission === 'boolean' ? downloadPermission : orgDownloadPermission;

      if (desiredAccess !== orgAccess.access.title) {
        enqueue({ kind: ActionKind.PATCH_ACCESS, when: Date.now(), accessId: orgAccess.id, access: desiredAccess });
      }
      if (desiredAllow !== orgAccess.allow_downloads) {
        enqueueDownload(orgAccess.id, desiredAllow);
      }
      setNewOrganizationAccess(undefined);
      return;
    }

    const orgId = thisFeed!.organization_id.toString();
    const desiredAllow = typeof downloadPermission === 'boolean' ? downloadPermission : orgDownloadPermission;
    const desiredAccess = access?.value || newOrganizationAccess?.[orgId]?.access || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;

    obj = {
      ...newOrganizationAccess,
      [orgId]: {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        organization: orgId,
        type: 'organization',
        allowDownloads: desiredAllow,
        access: desiredAccess,
      },
    };

    const updated = updateCreateDraft('organization', orgId, { access: desiredAccess, allowDownloads: desiredAllow });
    if (!updated) {
      enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: obj[orgId] });
    }
    setNewOrganizationAccess(obj);
  };

  // ===== notify msg =====
  const [notify, setNotify] = useState(false);
  const [messageTextForSharedContent, setMessageText] = useState('');
  const switchNotify = () => {
    setNotify(!notify);
    setMessageText('');
  };
  const onMessageTextInput = (e: any) => setMessageText(e.target.value);

  const canNotifyNewUsers = plannedOps.some(
    (action) => action.kind === ActionKind.CREATE_ACCESS || action.kind === ActionKind.PATCH_ACCESS,
  );

  useEffect(() => {
    if (!canNotifyNewUsers && notify) {
      setNotify(false);
    }
  }, [canNotifyNewUsers, notify]);

  // ===== new exclusions =====
  const [newExcludedUsers, setNewExcludedUsers] = useState<(USER_NEW | GROUP)[]>([]);
  const [newExcludedUsersAccess, setNewExcludedUsersAccess] = useState<NewAccessType>();
  const filterEntries = (obj: any) => {
    const userIdsToRemove = new Set();
    const groupIdsToRemove = new Set();
    for (const elem of Object.values(obj)) {
      const entry = elem as any;
      if (entry.type === 'group') {
        if (Array.isArray(entry.members)) entry.members.forEach((id: any) => userIdsToRemove.add(String(id)));
        if (Array.isArray(entry.subgroups)) entry.subgroups.forEach((id: any) => groupIdsToRemove.add(String(id)));
      }
    }
    const result = {} as any;
    for (const [key, elem] of Object.entries(obj)) {
      const entry = elem as any;
      if (entry.type === 'user' && userIdsToRemove.has(String(entry.user))) continue;
      if (entry.type === 'group' && groupIdsToRemove.has(String(entry.group))) continue;
      result[key] = entry;
    }
    return result;
  };

  // ===== helpers for restoring subgroup =====// для пошуку сабів у нових
  const getParentCurrentAccessAndAllow = (parentGroupId: string) => {
    const parent = groupAccessList.find((a) => a.group?.id === parentGroupId);
    const mapEntry = accessMapJson.find((g) => g.id === parentGroupId);

    if (parent) {
      const patched = groupAccess?.[parent.id]?.access;
      const mapped = mapEntry?.access;
      const accessTitle = patched ?? mapped ?? parent.access.title;
      const allow = (downloadPermissions[parent.id]?.allowDownload ?? parent.allow_downloads ?? true) as boolean;
      return { accessTitle, allow, mode: 'existing' as const, accessId: parent.id };
    }

    const isNewParent = newGroupsState.find((g) => g.id === parentGroupId);
    if (isNewParent) {
      const ng = newGroupAccess?.[parentGroupId];
      const mapped = mapEntry?.access;
      const accessTitle = ng?.access ?? mapped ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const allow = (ng?.allowDownloads ?? getDefaultShareAllowDownloads()) as boolean;
      return { accessTitle, allow, mode: 'new' as const, accessId: undefined };
    }

    return { accessTitle: null, allow: null, mode: 'none' as const, accessId: undefined };
  };

  const restoreSubgroupAfterExclusionRemoval = (subgroupId: string) => {
    const parentGroup = allGroups.find((g) => g.subgroups?.some((s) => s.id === subgroupId));
    if (!parentGroup) return;

    const parentPresent =
      groupAccessList.some((a) => a.group?.id === parentGroup.id) || newGroupsState.some((g) => g.id === parentGroup.id);
    if (!parentPresent) return;

    const parent = getParentCurrentAccessAndAllow(parentGroup.id);
    if (parent.accessTitle === null) return;

    let accessToApply = parent.accessTitle!;
    let allowToApply = parent.allow!;
    let markExcluded = true;

    if (accessToApply === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
      const orgEff = getEffectiveOrganizationAccess();
      if (orgEff.exists) {
        accessToApply = orgEff.access!;
        allowToApply = orgEff.allow!;
      } else {
        accessToApply = ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
        allowToApply = false;
        markExcluded = false;
      }
    }

    // оновити локальну мапу
    const mapCopy = lodash.cloneDeep(accessMapJson);
    const pIdx = mapCopy.findIndex((g) => g.id === parentGroup.id);
    if (pIdx >= 0) {
      const sIdx = mapCopy[pIdx].subGroups.findIndex((s) => s.id === subgroupId);
      if (sIdx >= 0) mapCopy[pIdx].subGroups[sIdx] = { id: subgroupId, access: accessToApply };
      else mapCopy[pIdx].subGroups.push({ id: subgroupId, access: accessToApply });
      setAccessMapJson(mapCopy);
    }

    const existingSub = subGroupAccessList.find((a) => a.group?.id === subgroupId);
    if (existingSub) {
      enqueue({
        kind: ActionKind.PATCH_ACCESS,
        when: Date.now(),
        accessId: existingSub.id,
        access: accessToApply,
        ...(typeof markExcluded === 'boolean' ? { excluded: markExcluded } : {}),
      });
      enqueueDownload(existingSub.id, allowToApply);
      setDownloadPermissions((prev) => ({ ...prev, [existingSub.id]: { allowDownload: allowToApply } }));
    } else {
      const body = {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        group: subgroupId,
        allowDownloads: allowToApply,
        type: 'group',
        access: accessToApply,
        excluded: markExcluded,
      };
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          // @ts-ignore
          targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
          targetId: thisFeed!.id,
          group: subgroupId,
          allowDownloads: allowToApply,
          type: 'group',
          access: accessToApply,
          excluded: markExcluded,
        },
      });
      setNewGroupAccess((prev) => ({ ...(prev ?? {}), [subgroupId]: body as any }));
    }
  };

  // ===== submit =====
  const createUrl = () => {
    const folderId = findSearchValue('folderId');
    let finalType: string;
    switch (shareFolderForSharedWithMe?.type) {
      case VIDEOFEED_TYPE.COMPOSER:
      case VIDEOFEED_TYPE.MY_COMPOSER:
        finalType = PATHS.COMPOSER_PAGE.path;
        break;
      default:
        finalType = PATHS.TIMELINE.path;
    }
    const result = `${finalType}?feedId=${shareFolderForSharedWithMe?.id}&shared=true&fileside=true&folderId=${folderId}&feed=0&clipId=${shareFolderForSharedWithMe?.videos[0].id}&clip=0&pageType=${shareFolderForSharedWithMe?.type}`;
    return result;
  };

  const drainQueue = async (redirectUrlToSend: string) => {
    const selectedShareScope: 'single' | 'collection' =
      currentShareScope === 'collection'
        ? 'collection'
        : 'single';
    const q = actionQ.current;
    let i = 0;
    while (i < q.length) {
      const a = q[i];

      if (a.kind === ActionKind.CREATE_ACCESS) {
        const batch: CreateAccessBody[] = [];
        while (i < q.length && q[i].kind === ActionKind.CREATE_ACCESS) {
          batch.push((q[i] as CreateAccessAction).body);
          i++;
        }
        await postArrayOfNewAccesses(
          batch.map((body) => ({
            ...body,
            share_scope: body.share_scope || selectedShareScope,
            notify: body.doNotNotify ? false : notify,
            contentUrl: redirectUrlToSend,
            messageTextForSharedContent,
            ...(typeof (body as any).excluded === 'boolean' ? { excluded: (body as any).excluded } : {}),
          })),
        );
        continue;
      }

      switch (a.kind) {
        case ActionKind.DELETE_ACCESS: {
          const { accessId } = a as DeleteAccessAction;
          await deleteAccess(accessId);
          break;
        }
        case ActionKind.PATCH_ACCESS: {
          const { accessId, access, doNotNotify, excluded, share_scope } = a as PatchAccessAction;
          await patchFolderAccess({
            accessId,
            access: access as ACCESS_TYPE,
            share_scope: share_scope || getAccessShareScope(accessId),
            notify: doNotNotify ? false : notify,
            contentUrl: redirectUrlToSend,
            messageTextForSharedContent,
            ...(typeof excluded === 'boolean' ? { excluded } : {}),
          });
          break;
        }
        case ActionKind.PATCH_DOWNLOAD: {
          const { accessId, allowDownload } = a as PatchDownloadAction;
          await patchAccessDownloadPermission(accessId, allowDownload);
          break;
        }
      }
      i++;
    }
  };

  const getAccessLabel = (access: any) => {
    if (!canManageCollectionShareScope) return null;
    const selectedShareScope = currentShareScope;
    const accessShareScope = String(access?.share_scope || 'single').toLowerCase();
    const sharedTimelineCount = Number(access?.shared_reference_timeline_count || 0);

    if (
      accessShareScope === 'single' &&
      sharedTimelineCount === 0 &&
      (selectedShareScope !== 'collection' || !upgradedCollectionAccessIds.includes(access.id))
    ) {
      return 'Collection only';
    }

    return null;
  };

  const getShareAllTimelines = (access: any) => {
    if (typeof shareScopeOverrides[access.id] === 'boolean') return shareScopeOverrides[access.id];
    const sharedCount = Number(access?.shared_reference_timeline_count || 0);
    const totalCount = Number(access?.reference_timeline_count || 0);
    if (totalCount > 0) return sharedCount >= totalCount;
    return String(access?.share_scope || '').toLowerCase() === 'collection';
  };

  const isExcludedAccess = (a: FILE_ACCESS_TYPE) => {
    const title = a?.access?.title as ACCESS_TYPE_ENUM | undefined;
    const excludedFlag = a?.excluded;
    return title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && (typeof excludedFlag === 'boolean' ? excludedFlag : true);
  };

  const onSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const contentUrl = createUrl();

      // спочатку відпрацюємо відкладені deleteAccess (залишаємо — як у попередній реалізації)
      if (pendingDeleteIds.length) {
        for (const accessId of pendingDeleteIds) {
          await deleteAccess(accessId);
        }
      }

      // тепер черга CREATE/PATCH/PATCH_DOWNLOAD
      await drainQueue(contentUrl);

      // нотифікації окремо
      if (idsToRenotify && (idsToRenotify.userIds.length || idsToRenotify.groupIds.length)) {
        await postRenotify(idsToRenotify, contentUrl, messageTextForSharedContent);
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(getFoldersThunk({ page, limit, sortOption }));
      closeModal();
      setNotify(false);
      onUpdate?.({});
      refetchFeeds?.();
      setLoading(false);
      // cleanup
      setPendingDeleteIds([]);
      actionQ.current = [];
      setPlannedOps([]);
      setHasPending(false);
    }
  };

  // ===== close / delete handlers =====
  const closeModal = () => {
    dispatch(removeSelectedFolder());
    dispatch(updateSharedFeed(null));
    dispatch(switchShareModal(false));

    setSearchedUsers([]);
    setSearchText('');
    setSearchedGroups([]);
    setSearchedExclusions([]);
    setSearchExclusionsText('');
    setSearchGroupText('');

    setUsersAccess(undefined);
    setGroupAccess(undefined);
    setNewExcludedUsersAccess(undefined);
    setNewUsers([]);
    setNewGroups([]);
    setUserList([]);
    setNewExcludedUsers([]);
    setShareWithOrganization(false);
    setNewOrganizationAccess(undefined);
    setGroupAccessList([]);
    setExcludedUsersAccessList([]);
    setNewGroupAccess(undefined);
    setNewUsersAccess(undefined);
    setIdsToRenotify(null);
    setRenotifyAll(false);
    setAccessMapJson([]);
    setShowFolderAccessList(false);
    setMessageText('');
    setPendingDeleteIds([]);
    setUpgradedCollectionAccessIds([]);

    actionQ.current = [];
    setPlannedOps([]);
    setHasPending(false);
  };

  const onNewUserClick = (user: USER_NEW, index: number) => {
    setNewUsers([user, ...newUsers]);
    searchedUsers.splice(index, 1);
    setSearchedUsers([...searchedUsers]);
    const allowDownloads = getDefaultShareAllowDownloads(user.role?.title || user.user.role?.title);

    const body = {
      // @ts-ignore
      targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
      targetId: thisFeed!.id,
      user: user.user.id,
      allowDownloads,
      type: 'user',
      access: ACCESS_TYPE_KEYS[ACCESS_TYPE.COMMENT_AND_CREATE],
      share_scope: defaultAccessShareScope,
    };
    enqueue({
      kind: ActionKind.CREATE_ACCESS,
      when: Date.now(),
      body: {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        user: user.user.id,
        allowDownloads,
        type: 'user',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.COMMENT_AND_CREATE],
        share_scope: defaultAccessShareScope,
      },
    });

    const obj: NewAccessType = {
      ...(newUsersAccess ?? {}),
      [user.user.id]: body as any,
    };
    setNewUsersAccess(obj);
  };

  const onNewExcludedUserClick = (data: USER_NEW | GROUP, index: number) => {
    setNewExcludedUsers([data, ...newExcludedUsers]);
    searchedExclusions.splice(index, 1);
    setSearchedExclusions([...searchedExclusions]);

    let newEntry: any;
    if ('user_name' in data) {
      const u = data as USER_NEW;
      newEntry = {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        allowDownloads: false,
        user: u.user.id,
        type: 'user',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.NO_ACCESS],
        excluded: true,
      };
    } else {
      const g = data as GROUP;
      newEntry = {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        group: g.id,
        allowDownloads: false,
        members: g.members ? g.members.map((m) => m.id) : [],
        subgroups: g.subgroups ? g.subgroups.map((s) => s.id) : [],
        type: 'group',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.NO_ACCESS],
        excluded: true,
      };
    }

    const key = newEntry.user ?? newEntry.group;
    setNewExcludedUsersAccess((prev) => ({ ...(prev ?? {}), [key]: newEntry }));

    enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: { ...newEntry } });
  };

  const onNewGroupClick = (group: GROUP, index: number) => {
    setNewGroups((prev) => [group, ...prev]);
    setNewGroupsState((prev) => [group, ...prev]); // локально для restore helper
    searchedGroups.splice(index, 1);
    setSearchedGroups([...searchedGroups]);

    const baseAccess = ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
    enqueue({
      kind: ActionKind.CREATE_ACCESS,
      when: Date.now(),
      body: {
        // @ts-ignore
        targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
        targetId: thisFeed!.id,
        group: group.id,
        allowDownloads: getDefaultShareAllowDownloads(),
        type: 'group',
        access: baseAccess,
        share_scope: defaultAccessShareScope,
      },
    });

    const accessMapJsonCopied = lodash.cloneDeep(accessMapJson);
    if (group.subgroups.length) {
      group.subgroups.forEach((sub) => {
        const excludedSubgroup =
          excludedUsersAccessList
            .filter((elem) => elem.type === 'group')
            .map((groupAcc) => groupAcc.group!.id)
            .includes(sub.id) || (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]).map((g) => g.id).includes(sub.id);

        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: {
            // @ts-ignore
            targetType: AccessTargetType[thisFeed?.type as keyof typeof AccessTargetType] ?? AccessTargetType.TIMELINE,
            targetId: thisFeed!.id,
            group: sub.id,
            allowDownloads: excludedSubgroup ? false : getDefaultShareAllowDownloads(),
            type: 'group',
            access: excludedSubgroup ? ACCESS_TYPE_ENUM.WITHOUT_ACCESS : baseAccess,
            share_scope: defaultAccessShareScope,
          },
        });
      });
      accessMapJsonCopied.push({
        id: group.id,
        access: baseAccess,
        subGroups: group.subgroups.map((s) => {
          const excludedSubgroup =
            excludedUsersAccessList
              .filter((elem) => elem.type === 'group')
              .map((groupAcc) => groupAcc.group!.id)
              .includes(s.id) || (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]).map((g) => g.id).includes(s.id);
          return { id: s.id, access: excludedSubgroup ? ACCESS_TYPE_ENUM.WITHOUT_ACCESS : baseAccess };
        }),
      });
    } else {
      accessMapJsonCopied.push({ id: group.id, access: baseAccess, subGroups: [] });
    }

    setAccessMapJson(accessMapJsonCopied);
  };

  // маленький state для restore helper
  const [newGroupsState, setNewGroupsState] = useState<GROUP[]>([]);

  const onSearchResultsDismiss = () => {
    setSearchedUsers([]);
    setSearchText('');
  };
  const onGroupSearchResultsDismiss = () => {
    setSearchedGroups([]);
    setSearchGroupText('');
  };
  const onSearchExcludedUsersResultsDismiss = () => {
    setSearchedExclusions([]);
    setSearchExclusionsText('');
  };

  const handleDeleteAccess = (accessId: string, accessType?: 'user' | 'group' | 'subgroup' | 'organization', groupId?: string) => {
    try {
      if (accessType === 'group') {
        const subgroupIds = groupAccessList.find((obj) => obj.id == accessId)?.group?.subgroups.map((sub) => sub.id) || [];
        const subgroupAccessIds = subGroupAccessList.filter((subAcc) => subgroupIds.includes(subAcc.group.id)).map((subAcc) => subAcc.id);
        subgroupAccessIds.forEach((sid) => enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId: sid }));
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });

        setGroupAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setSubGroupAccessList((prev) => prev.filter((a) => !subgroupIds.includes(a.group.id)));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
      } else if (accessType === 'subgroup') {
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });

        setUserList((prev) => prev.filter((a) => a.id !== accessId));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setSubGroupAccessList((prev) => prev.filter((a) => a.id !== accessId));

        // захист: якщо батьківська група/саб немає в доступах — просто видаляємо
        if (groupId) {
          const parentGroup = allGroups.find((g) => g.subgroups?.some((s) => s.id === groupId));
          const parentPresent =
            !!parentGroup && (groupAccessList.some((a) => a.group.id === parentGroup.id) || newGroups.some((g) => g.id === parentGroup.id));
          const subgroupPresent = subGroupAccessList.some((a) => a.group.id === groupId) || !!newGroupAccess?.[groupId];

          if (!parentPresent && !subgroupPresent) {
            return;
          }
        }

        if (groupId) {
          const parent = accessMapJson.find((g) => g.subGroups.some((s) => s.id === groupId));
          const parentId = parent?.id;
          const parentAccessTitle = normalizeAccessTitle(parent?.access);

          let desiredAccess: ACCESS_TYPE_ENUM;
          let desiredExclusion = true;
          let desiredAllow: boolean;

          if (parentAccessTitle && parentAccessTitle !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
            desiredAccess = parentAccessTitle;
            const parentAcc = parentId ? groupAccessList.find((ga) => ga.group.id === parentId) : undefined;
            const parentAllow =
              (parentAcc && (downloadPermissions[parentAcc.id]?.allowDownload ?? parentAcc.allow_downloads)) ??
              getDefaultShareAllowDownloads();
            desiredAllow = !!parentAllow;
          } else {
            const orgEff = getEffectiveOrganizationAccess();
            if (orgEff.exists) {
              desiredAccess = orgEff.access!;
              desiredAllow = orgEff.allow!;
            } else {
              desiredAccess = ACCESS_TYPE_ENUM.NO_ACCESS;
              desiredAllow = false;
              desiredExclusion = false;
            }
          }

          const existingSubAccess = subGroupAccessList.find((sa) => sa.group.id === groupId);

          if (existingSubAccess) {
            enqueue({
              kind: ActionKind.PATCH_ACCESS,
              when: Date.now(),
              accessId: existingSubAccess.id,
              access: desiredAccess,
              doNotNotify: false,
              excluded: desiredExclusion,
            });

            setAccessMapJson((prev) =>
              prev.map((g) =>
                g.id !== (parentId || g.id)
                  ? g
                  : { ...g, subGroups: g.subGroups.map((s) => (s.id === groupId ? { ...s, access: desiredAccess } : s)) },
              ),
            );

            setDownloadPermissions((prev) => ({
              ...prev,
              [existingSubAccess.id]: { allowDownload: desiredAllow },
            }));
            enqueueDownload(existingSubAccess.id, desiredAllow);
          } else {
            const draft: NewAccessType = {
              ...(newGroupAccess || {}),
              [groupId]: {
                targetType: 'online_composer',
                targetId: thisFeed!.id,
                group: groupId,
                allowDownloads: desiredAllow,
                type: 'group',
                access: desiredAccess,
                excluded: desiredExclusion,
                doNotNotify: false,
              },
            };

            setNewGroupAccess(draft);

            actionQ.current = actionQ.current.filter(
              (a) =>
                !(
                  a.kind === ActionKind.CREATE_ACCESS &&
                  (a as CreateAccessAction).body.type === 'group' &&
                  (a as CreateAccessAction).body.group === groupId
                ),
            );

            enqueue({
              kind: ActionKind.CREATE_ACCESS,
              when: Date.now(),
              body: draft[groupId] as any,
            });

            setAccessMapJson((prev) =>
              prev.map((g) =>
                g.id !== (parentId || g.id)
                  ? g
                  : { ...g, subGroups: g.subGroups.map((s) => (s.id === groupId ? { ...s, access: desiredAccess } : s)) },
              ),
            );
          }
        }
      } else {
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });
        setUserList((prev) => prev.filter((a) => a.id !== accessId));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
      }

      queueDeletion(accessId);
    } catch (error: any) {
      notification.showMessage(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (!searchedExclusions.length) return;

    const raf = requestAnimationFrame(() => {
      const wrapper = contentWrapperRef.current;
      const container = searchExcludedUsersResultBarRef.current as HTMLDivElement | null;

      if (!wrapper || !container) return;

      const list = container.querySelector(`.${css.searchList}`) as HTMLElement | null;
      const firstItem = (list?.querySelector(`.${css.user}`) as HTMLElement | null) || (list?.firstElementChild as HTMLElement | null);

      if (!firstItem) return;

      firstItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });

      const wRect = wrapper.getBoundingClientRect();
      const fRect = firstItem.getBoundingClientRect();
      if (fRect.bottom > wRect.bottom) {
        wrapper.scrollBy({ top: fRect.bottom - wRect.bottom + 8, behavior: 'smooth' });
      }
    });

    return () => cancelAnimationFrame(raf);
  }, [searchedExclusions.length]);

  const handleDeleteNewUser = (userId: string) => {
    setNewUsers((prev) => prev.filter((obj) => obj.user.id !== userId));
    cancelCreateFor((a) => a.body.type === 'user' && a.body.user === userId);
    if (newUsersAccess) {
      delete newUsersAccess[userId];
      setNewUsersAccess(Object.keys(newUsersAccess).length ? newUsersAccess : undefined);
    }
    refetchFeeds?.();
  };

  const handleDeleteNewGroup = (groupId: string) => {
    setNewGroups((prev) => prev.filter((g) => g.id !== groupId));
    setNewGroupsState((prev) => prev.filter((g) => g.id !== groupId));
    // прибрати CREATE для групи та її сабів
    const subs = (newGroupsState.find((g) => g.id === groupId)?.subgroups ?? []).map((s) => s.id);
    actionQ.current = actionQ.current.filter((a) => {
      if (a.kind !== ActionKind.CREATE_ACCESS) return true;
      const c = a as CreateAccessAction;
      return !(c.body.type === 'group' && (c.body.group === groupId || subs.includes(c.body.group!)));
    });
    syncPlanned();

    if (newGroupAccess) {
      delete newGroupAccess[groupId];
      setNewGroupAccess(Object.keys(newGroupAccess).length ? newGroupAccess : undefined);
    }
    refetchFeeds?.();
  };

  const handleDeleteOrganization = () => {
    const orgAccess = thisFeed?.access.find((access) => access.type === 'organization');
    if (orgAccess) {
      handleDeleteAccess(orgAccess.id, 'organization');
      queueDeletion(orgAccess.id);
    }

    setNewExcludedUsers([]);
    setNewOrganizationAccess(undefined);
    setShareWithOrganization(false);
  };

  const handleDeleteNewExcludedUser = (userId: string) => {
    setNewExcludedUsers((prev) => prev.filter((user) => user.id !== userId));
    if (newExcludedUsersAccess) {
      delete newExcludedUsersAccess[userId];
      setNewExcludedUsersAccess(Object.keys(newExcludedUsersAccess).length ? newExcludedUsersAccess : undefined);
    }
  };

  useOnClickOutside(searchResultBarRef, onSearchResultsDismiss);
  useOnClickOutside(searchExcludedUsersResultBarRef, onSearchExcludedUsersResultsDismiss);
  useOnClickOutside(searchGroupResultBarRef, onGroupSearchResultsDismiss);

  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    if (!event.currentTarget.className.includes('Mui-focusVisible')) {
      setExpanded(isExpanded ? panel : false);
    }
  };

  useHotkeys('Enter', () => {
    if (isOpen && !loading) submitButtonRef?.current?.click();
  });

  // ===== folder access list (informational) =====
  const [showFolderAccessList, setShowFolderAccessList] = useState(false);
  const [folderLoading, setFolderLoading] = useState(false);
  const [folderAccess, setFolderAccess] = useState<{
    users: FILE_ACCESS_TYPE[];
    exclusions: FILE_ACCESS_TYPE[];
    groups: { group: FILE_ACCESS_TYPE; subgroups: FILE_ACCESS_TYPE[] }[];
    collaborators: USER[];
    groupCollaborators: GROUP[];
  }>({
    users: [],
    exclusions: [],
    groups: [],
    collaborators: [],
    groupCollaborators: [],
  });

  const fetchFolderAccessess = async () => {
    setFolderLoading(true);
    const folderId = findSearchValue('folderId');
    try {
      const res = await getFolderAccessessById(`${folderId}`);
      if (res.data) {
        const collaborators = res.data?.collaborators || [];
        const groupCollaborators = res.data?.group_collaborators || [];
        const users = res.data.access.filter(
          (item: FILE_ACCESS_TYPE) =>
            (item?.type === SHARE_TYPE.USER || item?.type === 'organization') &&
            item.access.title !== ACCESS_TYPE_ENUM.WITHOUT_ACCESS,
        );
        const excludedEntries = res.data.access.filter(
          (item: FILE_ACCESS_TYPE) => item.access.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded,
        );
        let mainGrps = res.data?.access.filter(
          (item: FILE_ACCESS_TYPE) =>
            item?.group?.type === GROUP_TYPE.GROUP && !(item?.access?.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded),
        );
        mainGrps = mainGrps.map((item: FILE_ACCESS_TYPE) => {
          let result: any = {};
          if (item.group.type === 'GROUP') {
            result.group = item;
            result.subgroups = res.data.access.filter((access: FILE_ACCESS_TYPE) => {
              if (access?.group?.type === GROUP_TYPE.SUBGROUP) {
                let subgrp = item?.group?.subgroups.find((sg) => sg.id == access?.group?.id);
                return subgrp;
              }
            });
          }
          return result;
        });

        // @ts-ignore
        setFolderAccess({ users, exclusions: excludedEntries, groups: mainGrps, collaborators, groupCollaborators });
        setShowFolderAccessList(true);
      }
    } catch (err: any) {
      console.log(err);
      if (err?.response?.data?.message) notification.showMessage(err?.response?.data?.message);
    } finally {
      setFolderLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={closeModal} loading={loading} mobileFullScreen>
      <form className={css.modalBody} onSubmit={onSubmit}>
        <div className={css.modalTitle}>Share {`“${thisFeed?.title}”`}</div>
        <div className={css.contentWrapper} ref={contentWrapperRef}>
          <div className={css.organizationAccessWrapper}>
            <div className={css.notifyCheckBox}>
              <div className={css.checkboxWrapper30}>
                <span className={css.checkbox}>
                  <input
                    type="checkbox"
                    onChange={() => {
                      if (!shareWithOrganization) onNewOrganizationAccessChange(USER_SHARE_OPTIONS[2], true);
                      else handleDeleteOrganization();
                      setShareWithOrganization(!shareWithOrganization);
                    }}
                    checked={shareWithOrganization}
                  />
                  <svg>
                    <use xlinkHref="#checkbox-30" className={css.checkbox}></use>
                  </svg>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                  <symbol id="checkbox-30" viewBox="0 0 22 22">
                    <path
                      fill="none"
                      stroke="currentColor"
                      d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                    />
                  </symbol>
                </svg>
                Share to All Users?
              </div>
            </div>
            {shareWithOrganization && (
              <div className={css.organizationAccessListWrapper}>
                <AllUsersList
                  css={css}
                  orgDownloadPermission={orgDownloadPermission}
                  onOrgDownloadPermissionChange={canGrantDownloads ? onOrgDownloadPermissionChange : undefined}
                  orgAccess={thisFeed?.access.find((access) => access.type === 'organization')}
                  onNewOrganizationAccessChange={onNewOrganizationAccessChange}
                  onOrganizationDelete={handleDeleteOrganization}
                />
              </div>
            )}
          </div>

          <div className={css.sectionTitle}>Groups & subgroups with access</div>
          <SearchInput className={css.search} onChange={onGroupSearch} placeHolder="Search groups" />
          <div ref={searchGroupResultBarRef} className={css.searchResultContainer}>
            {!!searchedGroups?.length && (
              <div className={css.searchList}>
                {searchedGroups.map((group: GROUP, i: number) => {
                  const excluded =
                    (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                      .map((g) => [g.id, g.subgroups.map((sub) => sub.id)])
                      .flat(Infinity)
                      .includes(group.id) ||
                    excludedUsersAccessList
                      .filter((elem) => elem.group)
                      .map((g) => +g.group!.id)
                      .includes(+group.id);
                  return (
                    <div
                      className={cs(css.user, excluded && css.excludedUsers)}
                      key={group.id}
                      onClick={!excluded ? () => onNewGroupClick(group, i) : undefined}
                    >
                      <div className={css.username}>{group?.title}</div>
                      <div className={css.groupPeople}>{group?.analysts.length + group.viewers.length} people</div>
                      <div className={css.groupLabel}>Group</div>
                    </div>
                  );
                })}
              </div>
            )}
            {searchGroupText.trim().length > 0 && isGroupSearchEmpty && !isGroupSearchLoading && (
              <div className={css.noResults}>No Groups Found</div>
            )}
          </div>

          <ShareFolderModalGroupList
            newExcludedGroups={newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]}
            excludedUsersAccessList={excludedUsersAccessList.filter((elem) => elem.type === 'group')}
            onNewGroupDownloadPermissionChange={canGrantDownloads ? onNewGroupDownloadPermissionChange : undefined}
            onNewGroupShareScopeChange={canManageCollectionShareScope ? onNewGroupShareScopeChange : undefined}
            onDownloadPermissionChange={canGrantDownloads ? onDownloadPermissionChange : undefined}
            onShareScopeChange={canManageCollectionShareScope ? onShareScopeChange : undefined}
            getShareAllTimelines={canManageCollectionShareScope ? getShareAllTimelines : undefined}
            downloadPermissions={downloadPermissions}
            newGroupAccess={newGroupAccess}
            newGroups={newGroups}
            groupList={groupAccessList as unknown as FILE_ACCESS_TYPE_SHARED_WITH_ME_WITH_SUBGROUP[]}
            onGroupAccessChange={onGroupAccessChange}
            onNewGroupAccessChange={onNewGroupAccessChange}
            subGroupList={subGroupAccessList}
            onAccessDelete={handleDeleteAccess}
            onNewGroupDelete={handleDeleteNewGroup}
            addEntityToRenotify={addEntityToRenotify}
            idsToRenotify={idsToRenotify}
            accessMapJson={accessMapJson}
          />

          <div className={css.sectionTitle}>Additional Access</div>
          <div className={css.searchWrapper}>
            <SearchInput className={css.search} onChange={onUserSearch} />
            {(userList.length > 0 || groupAccessList.length > 0) && (
              <Tooltip title={renotifyAll ? 'Re-notify all on submit' : 'Re-notify all is off'}>
                <div
                  className={css.renotifyAll}
                  onClick={switchNotifyAll}
                >
                  Re-notify all?
                  <img src={renotifyAll ? BellIconFilled : BellIcon} alt="renotify all" className={css.bellIcon} />
                </div>
              </Tooltip>
            )}
          </div>

          <div ref={searchResultBarRef} className={css.searchResultContainer}>
            {searchedUsers.length > 0 && (
              <div className={css.searchList}>
                {searchedUsers.map((obj, i: number) => {
                  const excluded =
                    (newExcludedUsers.filter((elem) => 'user_name' in elem) as USER_NEW[]).map((u) => u.user.id).includes(obj.user.id) ||
                    (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                      .map((group) => group.members?.map((elem) => elem.id))
                      .flat()
                      .includes(obj.user.id) ||
                    excludedUsersAccessList
                      .filter((elem) => elem.user)
                      .map((u) => u.user!.id)
                      .includes(obj.user.id) ||
                    excludedUsersAccessList
                      .filter((elem) => elem.group)
                      .map((group) => [...(group.group.analysts || []), ...(group.group.viewers || [])].map((u) => u.id))
                      .flat(Infinity)
                      .includes(obj.user.id);
                  return (
                    <div
                      className={cs(css.user, excluded && css.excludedUsers)}
                      key={obj.user.id}
                      onClick={!excluded ? () => onNewUserClick(obj, i) : undefined}
                    >
                      <div>
                        <div className={css.username}>{obj.user?.username}</div>
                        {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                      </div>
                      <div>
                        <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {searchText.trim().length > 0 && isUserSearchEmpty && !isUserSearchLoading && (
              <div className={css.noResults}>No Users Found</div>
            )}
          </div>

          <ShareFolderModalUserList
            downloadPermissions={downloadPermissions}
            onDownloadPermissionChange={canGrantDownloads ? onDownloadPermissionChange : undefined}
            onNewUserDownloadPermissionChange={canGrantDownloads ? onNewUserDownloadPermissionChange : undefined}
            onNewUserShareScopeChange={canManageCollectionShareScope ? onNewUserShareScopeChange : undefined}
            onShareScopeChange={canManageCollectionShareScope ? onShareScopeChange : undefined}
            getShareAllTimelines={canManageCollectionShareScope ? getShareAllTimelines : undefined}
            newUsersAccess={newUsersAccess}
            newExcludedUsers={newExcludedUsers}
            excludedUsersAccessList={excludedUsersAccessList.filter((elem) => elem.type === 'user')}
            newUsers={newUsers}
            userList={userList}
            onNewUserAccessChange={onNewUserAccessChange}
            onUserAccessChange={onUserAccessChange}
            onAccessDelete={handleDeleteAccess}
            onNewUserDelete={handleDeleteNewUser}
            ownerId={thisFeed?.created_by.id}
            addEntityToRenotify={addEntityToRenotify}
            idsToRenotify={idsToRenotify}
            getAccessLabel={getAccessLabel}
            // @ts-ignore
            owner={thisFeed?.created_by ? thisFeed?.created_by : thisFeed?.owner}
          />

          <div className={css.sectionTitle}>Exclude Access</div>
          <div className={css.searchWrapper}>
            <SearchInput className={css.search} onChange={onExclusionsSearch} />
          </div>
          <div ref={searchExcludedUsersResultBarRef} className={css.searchResultContainer}>
            {searchedExclusions.length > 0 && (
              <div className={css.searchList}>
                {searchedExclusions.map((obj: USER_NEW | GROUP, i: number) => {
                  if ('user_name' in obj) {
                    if (obj.user.id === thisFeed?.created_by.id) return;
                    const isExcluded =
                      (newExcludedUsers.filter((elem) => 'user_name' in elem) as USER_NEW[])
                        .map((user) => user.user.id)
                        .includes(obj.user.id) ||
                      (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                        .map((group) => group.members?.map((elem) => elem.id))
                        .flat()
                        .includes(obj.user.id) ||
                      excludedUsersAccessList
                        .filter((elem) => elem.user)
                        .map((user) => user.user.id)
                        .includes(obj.user.id) ||
                      excludedUsersAccessList
                        .filter((elem) => elem.group)
                        .map((g) => [...(g.group.analysts || []), ...(g.group.viewers || [])].map((u) => u.id))
                        .flat(Infinity)
                        .includes(obj.user.id);
                    return (
                      <div
                        className={cs(css.user, isExcluded && css.excludedUsers)}
                        key={obj.user.id}
                        onClick={!isExcluded ? () => onNewExcludedUserClick(obj, i) : undefined}
                      >
                        <div>
                          <div className={css.username}>{obj.user?.username}</div>
                          {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                        </div>
                        <div>
                          <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                        </div>
                      </div>
                    );
                  } else {
                    const isExcluded = (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                      .map((group) => group.subgroups?.map((sub) => sub.id))
                      .flat()
                      .includes(obj.id);
                    return (
                      <div
                        className={cs(css.user, isExcluded && css.excludedUsers)}
                        key={obj.id}
                        onClick={!isExcluded ? () => onNewExcludedUserClick(obj, i) : undefined}
                      >
                        <div>
                          <div className={css.username}>{obj?.title}</div>
                          <div className={css.parentGroup}>{obj.parentGroup?.title}</div>
                        </div>
                        <div className={css.groupInfo}>
                          <div className={css.groupPeople}>{obj?.numberOfMembers} people</div>
                          {obj.type === GROUP_TYPE.GROUP ? (
                            <div className={css.groupLabel}>Group</div>
                          ) : (
                            <div className={css.subgroupLabel}>Subgroup</div>
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            )}
            {searchExclusionsText.trim().length > 0 && isExclusionsSearchEmpty && !isExclusionsSearchLoading && (
              <div className={css.noResultsExclude}>No Results Found</div>
            )}
          </div>

          <ShareModalExcludedUserList
            css={css}
            newUsers={newExcludedUsers}
            accessList={excludedUsersAccessList}
            onAccessDelete={handleDeleteAccess}
            onNewUserDelete={handleDeleteNewExcludedUser}
          />
        </div>

        {!showFolderAccessList && (
          <ContainedButton disabled={folderLoading} onClick={fetchFolderAccessess} style={{ marginBottom: '12px' }}>
            {' '}
            Show folder access list{' '}
          </ContainedButton>
        )}

        {showFolderAccessList && (
          <ContainedButton disabled={folderLoading} onClick={() => setShowFolderAccessList(false)} style={{ marginBottom: '12px' }}>
            {' '}
            Hide folder access list{' '}
          </ContainedButton>
        )}
        {folderLoading && <LinearProgress />}

        {showFolderAccessList && folderAccess.collaborators.length > 0 && (
          <>
            <div className={css.sectionTitle}>Folder Collaborators (users):</div>
            <div className={css.folderAccessList}>
              {folderAccess.collaborators.map((collaborator) => (
                <div className={css.accessItem} key={collaborator.id}>
                  <div className={css.userAccess}>
                    <div className={css.userAccessLeft}>
                      <Avatar
                        className={css.folderUserAvatar}
                        avatar={collaborator.avatar_url}
                        name={collaborator?.username || (canViewEmails ? collaborator.email : 'User')}
                      />
                      <div>
                        <div className={css.accessItemTitle}>{collaborator?.username}</div>
                        {canViewEmails && (<div className={css.accessItemTitle}>{collaborator?.email}</div>)}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {showFolderAccessList && folderAccess.groupCollaborators.length > 0 && (
          <>
            <div className={css.sectionTitle}>Folder Collaborators (groups):</div>
            <div className={css.folderAccessList}>
              {folderAccess.groupCollaborators.map((group) => (
                <div className={css.accessItem} key={group.id}>
                  <Tooltip
                    placement="top"
                    arrow
                    interactive
                    leaveDelay={200}
                    title={
                      <div className={css.tooltip200}>
                        {group?.analysts?.map((u) => (
                          <div key={`${u.id}_collab_tooltip`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ marginRight: '8px' }}>{u?.username ? u.username : (canViewEmails ? u.email : 'User')}</span>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className={css.userAccess}>
                      <div className={css.userAccessLeft}>
                        <div>
                          <div className={css.accessItemTitle}>{group?.title}</div>
                        </div>
                      </div>
                      <div className={css.data}>
                        <img src={UsersIcon} alt="users" />
                        {group?.analysts?.length || 0}
                      </div>
                    </div>
                  </Tooltip>
                </div>
              ))}
            </div>
          </>
        )}

        {showFolderAccessList && folderAccess.groups.length > 0 && (
          <>
            <div className={css.folderSectionTitle}>Folder Access (groups):</div>
            <div className={css.folderAccessList}>
              {folderAccess.groups.map((access) => (
                <Accordion
                  sx={{
                    padding: 0,
                    marginBottom: '8px',
                    backgroundColor: '#0f2336',
                    color: 'white',
                    boxShadow: 'none',
                    borderRadius: '4px',
                  }}
                  key={access.group.id}
                  expanded={expanded === access.group.id}
                  onChange={handleChange(access.group.id || 'emptyId')}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div className={css.groupItem}>
                      <div className={css.accessItemTitle}>{access.group.group?.title}</div>

                      <Tooltip
                        placement="right"
                        arrow
                        title={
                          <div className={css.tooltip}>
                            {' '}
                            {groupUsersOrganizer(access.group.group as any).map((u) => (
                              <div key={`${u.id}_tooltip`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                {' '}
                                <span style={{ marginRight: '8px' }}>{u?.username ? u.username : (canViewEmails ? u.email : 'User')} </span>{' '}
                              </div>
                            ))}{' '}
                          </div>
                        }
                      >
                        <div className={css.data}>
                          <img src={UsersIcon} alt="users" />
                          {groupUsersOrganizer(access.group.group as any).length}
                        </div>
                      </Tooltip>

                      <div className={css.accessItemRole}>{ACCESS_TYPE?.[access.group.access.title as ACCESS_TYPE_ENUM]}</div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={css.subgroupList}>
                      {access.subgroups.map((sub) => (
                        <div className={css.subgroupAccessItem} key={sub.group.id}>
                          <div className={css.accessItemTitle}>{sub.group.title}</div>
                          <Tooltip
                            placement="right"
                            arrow
                            title={
                              <div className={css.tooltip}>
                                {' '}
                                {groupUsersOrganizer(sub.group as any).map((u) => (
                                  <div key={`${u.id}_tooltip_sub`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {' '}
                                    <span style={{ marginRight: '8px' }}>{u?.username ? u.username : (canViewEmails ? u.email : 'User')} </span>{' '}
                                  </div>
                                ))}{' '}
                              </div>
                            }
                          >
                            <div className={css.data}>
                              <img src={UsersIcon} alt="users" />
                              {groupUsersOrganizer(sub.group as any).length}
                            </div>
                          </Tooltip>

                          <div className={css.accessItemRole}>{ACCESS_TYPE?.[sub.access.title as ACCESS_TYPE_ENUM]}</div>
                        </div>
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </>
        )}

        {showFolderAccessList && folderAccess.users.length > 0 && (
          <>
            <div className={css.sectionTitle}>Folder Access (users):</div>
            <div className={css.folderAccessList}>
              {folderAccess.users.map((access) => (
                <div className={css.accessItem} key={access.id}>
                  <div className={css.userAccess}>
                    <div className={css.userAccessLeft}>
                      <Avatar
                        className={css.folderUserAvatar}
                        avatar={access.user?.avatar_url}
                        name={access.type === 'organization' ? 'All Users' : access.user?.username || (canViewEmails ? access.user?.email : 'User')}
                      />
                      <div>
                        <div className={css.accessItemTitle}>{access.type === 'organization' ? 'All Users' : access.user?.username}</div>
                        {canViewEmails && access.type === SHARE_TYPE.USER && (<div className={css.accessItemTitle}>{access.user?.email}</div>)}
                      </div>
                    </div>
                    <div className={css.accessItemRole}>{ACCESS_TYPE?.[access.access.title as ACCESS_TYPE_ENUM]}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {showFolderAccessList && folderAccess.exclusions.length > 0 && (
          <>
            <div className={css.sectionTitle}>Folder Exclusions:</div>
            <div className={css.folderAccessList}>
              {folderAccess.exclusions.map((access) =>
                access.user ? (
                  <div className={css.accessItem} key={access.id}>
                    <div className={css.userAccess}>
                      <div className={css.userAccessLeft}>
                        <Avatar
                          className={css.folderUserAvatar}
                          avatar={access.user.avatar_url}
                          name={access.user?.username || (canViewEmails ? access.user.email : 'User')}
                        />
                        <div>
                          <div className={css.accessItemTitle}>{access.user?.username}</div>
                          {canViewEmails && (<div className={css.accessItemTitle}>{access.user?.email}</div>)}
                        </div>
                      </div>
                      <div className={css.accessItemRole}>{ACCESS_TYPE?.[access.access.title as ACCESS_TYPE_ENUM]}</div>
                    </div>
                  </div>
                ) : (
                  <div className={css.accessItem} key={access.id}>
                    <div className={css.userAccess}>
                      <div className={css.userAccessLeft}>
                        <div className={css.accessItemTitle}>{access.group?.title}</div>
                      </div>
                      <div className={css.accessItemRole}>{ACCESS_TYPE?.[access.access.title as ACCESS_TYPE_ENUM]}</div>
                    </div>
                  </div>
                ),
              )}
            </div>
          </>
        )}

        <div className={css.notifyCheckBox} style={!canNotifyNewUsers ? { opacity: 0.5 } : undefined}>
          <div className={css.checkboxWrapper30}>
            <span className={css.checkbox}>
              <input type="checkbox" onChange={switchNotify} checked={notify} disabled={!canNotifyNewUsers} />
              <svg>
                <use xlinkHref="#checkbox-30" className={css.checkbox}></use>
              </svg>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
              <symbol id="checkbox-30" viewBox="0 0 22 22">
                <path
                  fill="none"
                  stroke="currentColor"
                  d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                />
              </symbol>
            </svg>
            Notify New Users?
          </div>
        </div>

        {(notify || !!idsToRenotify?.groupIds?.length || !!idsToRenotify?.userIds?.length) && (
          <div className={css.messageText}>
            <textarea
              className={css.messageTextField}
              placeholder="Leave a message for them about content"
              style={{ resize: 'vertical', overflow: 'hidden' }}
              id="messageText"
              cols={33}
              onChange={onMessageTextInput}
              value={messageTextForSharedContent}
            />
          </div>
        )}
        <div className={css.actionBtns}>
          <OutlinedButton kind="default" type={'button'} onClick={closeModal} disabled={loading}>
            <div>Cancel</div>
          </OutlinedButton>
          <ContainedButton
            type={'submit'}
            disabled={
              !(hasPending || !!idsToRenotify?.groupIds?.length || !!idsToRenotify?.userIds?.length || pendingDeleteIds.length) || loading
            }
          >
            <div ref={submitButtonRef}>Confirm</div>
          </ContainedButton>
        </div>
      </form>
    </Modal>
  );
};

export default ShareFeedModal;
